var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_850_3297)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 58,
    fill: "url(#paint0_radial_850_3297)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.77 44.1998C57.57 44.1998 58.468 50.3398 58.468 50.3398V56.7198H71.972V58.7198H53.09C53.09 58.7198 44 57.5998 44 72.0098C44 86.4198 52.026 85.8338 52.026 85.8338H56.66V79.1118C56.66 79.1118 56.4 71.0858 64.46 71.0858H77.984C77.984 71.0858 85.528 71.2058 85.528 63.7818V51.5998C85.528 51.5998 86.672 44.1758 71.844 44.1758L71.77 44.1998ZM64.306 48.4738C64.7861 48.4617 65.259 48.5922 65.6649 48.8489C66.0708 49.1055 66.3914 49.4768 66.5863 49.9157C66.7812 50.3546 66.8416 50.8414 66.7597 51.3146C66.6779 51.7879 66.4576 52.2262 66.1267 52.5742C65.7958 52.9222 65.3691 53.1642 64.9005 53.2697C64.432 53.3752 63.9428 53.3394 63.4946 53.1668C63.0465 52.9942 62.6596 52.6926 62.3829 52.3001C62.1061 51.9076 61.952 51.4419 61.94 50.9618V50.9218C61.94 50.6029 62.0028 50.2872 62.1248 49.9926C62.2468 49.698 62.4257 49.4304 62.6511 49.2049C62.8766 48.9795 63.1443 48.8006 63.4388 48.6786C63.7334 48.5566 64.0492 48.4938 64.368 48.4938L64.306 48.4738Z",
    fill: "url(#paint1_linear_850_3297)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.17 99.8202C86.37 99.8202 85.472 93.6602 85.472 93.6602V87.3002H71.97V85.3002H90.91C90.91 85.3002 100 86.3162 100 71.9902C100 57.6642 91.974 58.1662 91.974 58.1662H87.28V64.8002C87.28 64.8002 87.54 72.8262 79.48 72.8262H65.95C65.95 72.8262 58.4 72.7122 58.4 80.1362V92.4002C58.4 92.4002 57.256 99.8242 72.084 99.8242H72.164L72.17 99.8202ZM79.634 95.5262C79.1539 95.5383 78.681 95.4078 78.2751 95.1511C77.8692 94.8945 77.5486 94.5232 77.3537 94.0843C77.1588 93.6454 77.0984 93.1586 77.1802 92.6853C77.2621 92.2121 77.4824 91.7738 77.8133 91.4258C78.1442 91.0778 78.5709 90.8358 79.0394 90.7303C79.508 90.6248 79.9972 90.6606 80.4454 90.8332C80.8935 91.0058 81.2804 91.3074 81.5571 91.6999C81.8339 92.0924 81.988 92.5581 82 93.0382V93.0982C82 93.7422 81.7442 94.3597 81.2888 94.8151C80.8335 95.2704 80.2159 95.5262 79.572 95.5262H79.632H79.634Z",
    fill: "url(#paint2_linear_850_3297)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_850_3297",
    x: 0,
    y: 0,
    width: 144,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_850_3297"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_850_3297",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72 72) rotate(85.4261) scale(54.5487)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA4B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_850_3297",
    x1: 49.5343,
    y1: 49.6456,
    x2: 76.1077,
    y2: 76.1587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_850_3297",
    x1: 65.255,
    y1: 66.9174,
    x2: 95.6154,
    y2: 93.4225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.587e2aeecff2be2daa496aa35626172c.svg";
export { ForwardRef as ReactComponent };